import {Injectable} from '@angular/core';
import {Profile} from '../domain/profile';
import {AuthService} from '../../core/security/auth.service';
import {ProfileService} from './profile.service';
import {ConfirmationService} from 'primeng/components/common/api';
import {User} from '../../core/domain/user';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class ProfileStoreService {

    private $profile: BehaviorSubject<Profile> = new BehaviorSubject<Profile>(null);

    profile: Observable<Profile>;

    constructor(private authService: AuthService,
                private profileService: ProfileService,
                private confirmationService: ConfirmationService) {

        this.profile = this.$profile.asObservable().filter(p => p != null);
        let userIn: User = null;
        this.authService.user
            .do(user => console.log('profile.next-user: ' + user.username))
            .do(user => userIn = user)
            .switchMap(user => this.profileService.getByUserId(user.id))
            .catch(e => {
                if (e.status === 404) {
                    console.log('404');
                    return this.confirmProfileCreate()
                        .filter(b => b)
                        .switchMap(b => {
                            const profile = new Profile();
                            profile.firstname = userIn.firstname;
                            profile.lastname = userIn.lastname;
                            return Observable.of(profile);
                        })
                } else return Observable.throw(e);
            })
            .subscribe(profile => this.$profile.next(profile));


    }

    getProfile(): Observable<Profile> {
        return this.$profile.asObservable().filter(p => p != null);
    }

    save(profile: Profile): Observable<Profile> {
        /**
        if (profile.id)
            profile.workPhone.id = this.$profile.getValue().workPhone.id;
         */
        return !profile.id ?
            this.profileService.create(profile)
                .do(profile => this.$profile.next(profile)) :
            this.profileService.update(profile)
                .do(profile => this.$profile.next(profile));
    }

    confirmProfileCreate(): Observable<boolean> {
        const confirm = new Subject<boolean>()
        this.confirmationService.confirm({
            header: 'Crear un nuevo perfil',
            message: '¿Usted no posee un perfil de usuario ¿desea crearlo ahora?',
            icon: 'fa ui-icon-add-circle-outline',
            accept: () => {
                confirm.next(true);
                confirm.complete();
            },
            reject: () => {
                confirm.next(false);
                confirm.complete();
            }
        })
        return confirm.asObservable()
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/service/profile-store.service.ts